import { render, staticRenderFns } from "./newListePropositionGazPro.vue?vue&type=template&id=72888670&scoped=true&"
import script from "./newListePropositionGazPro.vue?vue&type=script&lang=js&"
export * from "./newListePropositionGazPro.vue?vue&type=script&lang=js&"
import style0 from "./newListePropositionGazPro.vue?vue&type=style&index=0&id=72888670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72888670",
  null
  
)

export default component.exports